import * as React from "react"
import {
  ChakraProvider,
} from "@chakra-ui/react"
import Page from "./components/Page"
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import store from "./store";
import AuthWall from "./views/AuthWall";
import theme from "./theme/default";
import DialogProvider from "./hooks/useDialog";
import AppRoutes from "./AppRoutes";

export const App = () => (
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <DialogProvider>
          <AuthWall>
            <Page>
              <AppRoutes />
            </Page>
          </AuthWall>
        </DialogProvider>
      </BrowserRouter>
    </ChakraProvider>
  </Provider >
);
